import { ACTION_TYPES } from "./types"
import { ConfigurationDto } from "../models"
import { PatchPayload } from "../services/types"

export const Action = {
    fetch: () => {
        return {
            type: ACTION_TYPES.FETCH,
        }
    },

    fetchSuccess: (configuration: ConfigurationDto) => {
        return {
            type: ACTION_TYPES.FETCH_SUCCESS,
            payload: configuration,
        }
    },

    update: (payload: PatchPayload) => {
        return {
            type: ACTION_TYPES.UPDATE,
            payload: payload,
        }
    },

    save: () => {
        return {
            type: ACTION_TYPES.PATCH,
        }
    },
}






// WEBPACK FOOTER //
// ./src/state/inventory/configuration/actions/actions.ts